<template>
    <b-modal id="snelstartV2_manager_modal">
        <template slot="modal-title">Manage SnelStart v2 API connection</template>
        <b-form ref="snelstartV2_manager_modal_form" v-if="project_data.connections.indexOf('SnelStartV2') === -1">
            <b-button block
                      variant="primary"
                      :disabled="authorizing"
                      @click="authorize">
                Authorize
            </b-button>
        </b-form>
        <div v-if="project_data.connections.indexOf('SnelStartV2') >= 0">
            <b-button block
                      variant="danger"
                      :disabled="clearing_credentials"
                      @click="clearCredentials">
                Clear credentials
            </b-button>
        </div>
    </b-modal>
</template>
<script>
    import SnelStartV2ConnectionService from '../../../services/SnelStartV2ConnectionService';

    export default {
        props: {
            project_data: {
                type: Object,
                default: () => {
                }
            }
        },
        data() {
            return {
                snelstartV2_credentials: {},
                authorizing: false,
                clearing_credentials: false
            }
        },
        methods: {
            authorize(modal) {
                if (this.$refs.snelstartV2_manager_modal_form.checkValidity()) {
                    let self = this;
                    const body = {project_id: this.project_data.project_id}
                    this.authorizing = true;

                    SnelStartV2ConnectionService.authorize(body).then(res => {
                        if (res.data.success) {
                            this.$bvModal.hide('snelstartV2_manager_modal');
                            self.$emit('snelstartV2-authorization-complete', this.project_data.project_id);
                            window.open(res.data.auth_url, '_blank');
                        }
                        this.authorizing = false;
                    });
                } else {
                    modal.preventDefault();
                }
            },
            clearCredentials() {
                this.clearing_credentials = true;
                SnelStartV2ConnectionService.clearCredentials(this.project_data.project_id).then(res => {
                    if (res.data.success) {
                        this.project_data.connections = this.project_data.connections.filter(p => p !== 'SnelStartV2');
                    }
                    this.clearing_credentials = false;
                });
            }
        }
    }
</script>
